export enum ViolationFixMaterialTypesEnum {
  DOCUMENT = 'DOCUMENT_PRESENTATION',
  PHOTO = 'PHOTO_PRESENTATION',
  VIDEO = 'VIDEO_PRESENTATION',
  EXPLANATION = 'EXPLANATION_PRESENTATION',
  EVENT_RESULT = 'EVENT_PRESENTATION',
}
